import React, { useMemo } from 'react';
import { Document, Page, Text, View, StyleSheet, Font, Svg, Path, Rect, Image } from '@react-pdf/renderer';

try {
    Font.register({
        family: 'Arial',
        src: 'https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/Roboto-Regular.ttf'
    });
    Font.register({
        family: 'sans-serif',
        src: 'https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/Roboto-Regular.ttf'
    });
    Font.register({
        family: 'Arial, sans-serif',
        src: 'https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/Roboto-Regular.ttf'
    });
} catch (e) {
    console.warn("Advertencia al inicializar fuentes de fallback:", e);
}

const styles = StyleSheet.create({
    page: {
        padding: 0, 
        fontFamily: 'Helvetica',
        backgroundColor: '#ffffff',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%'
    },
    cuerpoSuperior: {
        display: 'flex',
        flexDirection: 'column'
    },

    /* ================= HEADER ORIGINAL RESTAURADO ================= */
    header: {
        backgroundColor: '#00183d',
        paddingTop: 30,
        paddingBottom: 50,
        paddingHorizontal: 40,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 15
    },
    headerTextGroup: {
        display: 'flex',
        flexDirection: 'column',
        gap: 1
    },
    titulo: {
        fontSize: 24,
        fontFamily: 'Helvetica-Bold',
        color: '#ffffff',
        lineHeight: 1.1
    },
    subtitulo: {
        fontSize: 12,
        color: '#ffffff',
        opacity: 0.85,
        marginTop: 2,
        fontFamily: 'Helvetica'
    },

    /* ================= CARDS ELEGANTES DE CONTROL ================= */
    card: {
        borderRadius: 12,
        borderWidth: 1.2,
        borderColor: '#e2e8f0',
        overflow: 'hidden',
        backgroundColor: '#ffffff',
        marginBottom: 7,
        marginHorizontal: 35
    },
    cardHeader: {
        backgroundColor: '#1e293b', 
        paddingVertical: 6,
        paddingHorizontal: 20,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
    },
    cardHeaderTitulo: {
        color: '#ffffff',
        fontSize: 10,
        fontFamily: 'Helvetica-Bold',
        textAlign: 'center',
        textTransform: 'uppercase'
    },
    cardHeaderDouble: {
        backgroundColor: '#ffffff',
        borderBottomWidth: 1,
        borderBottomColor: '#f0f2f5',
        paddingVertical: 6,
        paddingHorizontal: 20,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    cardHeaderDoubleTitulo: {
        color: '#64748b',
        fontSize: 9,
        fontFamily: 'Helvetica-Bold',
        textTransform: 'uppercase'
    },
    cardBodyDouble: {
        paddingVertical: 8,
        paddingHorizontal: 20,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    cardBodyDatoBlue: {
        fontSize: 11,
        color: '#00183d',
        fontFamily: 'Helvetica-Bold',
        lineHeight: 1.1
    },
    cardBodyDatoMuted: {
        fontSize: 11,
        color: '#00183d',
        fontFamily: 'Helvetica-Bold',
        lineHeight: 1.1
    },
    cardHeaderImpactoTitulo: {
        color: '#ffffff',
        fontFamily: 'Helvetica-Bold',
        fontSize: 10,
        textTransform: 'uppercase',
        letterSpacing: 0.5
    },

    /* ================= LISTADO DE ITEMS ================= */
    cardBodyList: {
        display: 'flex',
        flexDirection: 'column'
    },
    listItem: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingVertical: 6,
        paddingHorizontal: 20,
        borderBottomWidth: 1,
        borderBottomColor: '#f8fafc'
    },
    listItemLast: {
        borderBottomWidth: 0
    },
    listLabel: {
        fontSize: 10,
        color: '#64748b',
        fontFamily: 'Helvetica'
    },
    listValue: {
        fontSize: 10,
        color: '#00183d',
        fontFamily: 'Helvetica-Bold',
        lineHeight: 1.1
    },

    /* ================= TABLA DE COMPARATIVAS VECTORIAL ================= */
    tabla: {
        borderRadius: 12,
        borderWidth: 1.2,
        borderColor: '#e2e8f0',
        overflow: 'hidden',
        backgroundColor: '#ffffff',
        display: 'flex',
        flexDirection: 'column',
        marginBottom: 7,
        marginHorizontal: 35
    },
    fila: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        alignItems: 'stretch',
        borderBottomWidth: 1,
        borderBottomColor: '#f0f2f5'
    },
    filaHeader: {
        borderBottomWidth: 1.5,
        borderBottomColor: '#00183d'
    },
    celda: {
        paddingVertical: 6,
        paddingHorizontal: 12,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    celdaLabel: {
        width: '36%',
        borderRightWidth: 1,
        borderRightColor: '#f0f2f5',
        justifyContent: 'flex-start'
    },
    celdaDato: {
        width: '32%',
        justifyContent: 'center',
        borderRightWidth: 1,
        borderRightColor: '#f0f2f5'
    },
    celdaDatoLast: {
        width: '32%',
        justifyContent: 'center',
        borderRightWidth: 0
    },
    celdaHeaderLabel: {
        width: '36%',
        backgroundColor: '#00183d',
        borderRightWidth: 1,
        borderRightColor: '#1e293b',
        justifyContent: 'flex-start'
    },
    celdaHeaderDato: {
        width: '32%',
        backgroundColor: '#1e293b',
        borderRightWidth: 1,
        borderRightColor: '#00183d',
        justifyContent: 'center'
    },
    celdaHeaderDatoLast: {
        width: '32%',
        backgroundColor: '#00183d',
        justifyContent: 'center',
        borderRightWidth: 0
    },
    celdaTotalLabel: {
        width: '36%',
        borderTopWidth: 1.5,
        borderTopColor: '#00183d',
        backgroundColor: '#ffffff',
        borderRightWidth: 1,
        borderRightColor: '#f0f2f5',
        justifyContent: 'flex-start',
    },
    celdaTotalDato: {
        width: '32%',
        borderTopWidth: 1.5,
        borderTopColor: '#00183d',
        backgroundColor: '#ffffff',
        justifyContent: 'center',
        borderRightWidth: 1,
        borderRightColor: '#f0f2f5',
    },
    celdaTotalDatoLast: {
        width: '32%',
        borderTopWidth: 1.5,
        borderTopColor: '#00183d',
        backgroundColor: '#ffffff',
        justifyContent: 'center',
        borderRightWidth: 0
    },

    /* TEXTOS DE LA TABLA */
    textCeldaLabel: {
        fontSize: 9.5,
        color: '#64748b',
        fontFamily: 'Helvetica'
    },
    textCeldaDato: {
        fontSize: 9.5,
        color: '#00183d',
        fontFamily: 'Helvetica-Bold',
        textAlign: 'center',
        width: '100%'
    },
    textHeaderLabel: {
        color: '#ffffff',
        fontFamily: 'Helvetica-Bold',
        fontSize: 9.5,
        textTransform: 'uppercase'
    },
    textHeaderDato: {
        color: '#ffffff',
        fontFamily: 'Helvetica-Bold',
        fontSize: 9.5,
        textAlign: 'center',
        width: '100%',
        textTransform: 'uppercase'
    },
    textTotalLabel: {
        fontFamily: 'Helvetica-Bold',
        fontSize: 14,
        color: '#00183d'
    },
    textTotalDato: {
        fontFamily: 'Helvetica-Bold',
        fontSize: 9.5,
        color: '#00183d',
        textAlign: 'center',
        width: '100%',

    },

    /* ================= CHIPS VECTORIALES COMPRIMIDOS ================= */
    chip: {
        backgroundColor: '#f1f5f9',
        paddingVertical: 2,
        paddingHorizontal: 10,
        borderRadius: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    chipText: {
        color: '#00183d',
        fontFamily: 'Helvetica-Bold',
        fontSize: 9.5,
        textAlign: 'center'
    },
     chipTextFinal: {
        color: '#00183d',
        fontFamily: 'Helvetica-Bold',
        fontSize: 12,
        textAlign: 'center'
    },
    
    chipGreen: {
        backgroundColor: '#d1fae5',
        paddingVertical: 2,
        paddingHorizontal: 10,
        borderRadius: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    chipGreenText: {
        color: '#047857',
        fontFamily: 'Helvetica-Bold',
        fontSize: 9.5,
        textAlign: 'center'
    },
    chipGreenTextFinal: {
        color: '#047857',
        fontFamily: 'Helvetica-Bold',
        fontSize: 12, // ◄ SOLUCIÓN: Corregido el bug del tamaño 142 que provocaba el cuadro verde gigante
        textAlign: 'center'
    },
    chipCiiu: {
        backgroundColor: '#e0e7ff',
        paddingVertical: 2,
        paddingHorizontal: 10,
        borderRadius: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    chipCiiuText: {
        color: '#4f46e5',
        fontFamily: 'Helvetica-Bold',
        fontSize: 9,
        textAlign: 'center'
    },

    /* ================= IMPACTO FINANCIERO ADAPTADO ================= */
    cardImpacto: {
        borderRadius: 12,
        borderWidth: 1.2,
        borderColor: '#10b981',
        overflow: 'hidden',
        backgroundColor: '#e6f4ea',
        marginBottom: 7,
        marginHorizontal: 35
    },
    cardImpactoHeader: {
        backgroundColor: '#10b981',
        paddingVertical: 6,
        paddingHorizontal: 20,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
    },
    cardImpactoHeaderTitulo: {
        color: '#ffffff',
        fontFamily: 'Helvetica-Bold',
        fontSize: 10,
        textTransform: 'uppercase',
        letterSpacing: 0.5
    },
    listItemImpacto: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingVertical: 8,
        paddingHorizontal: 20,
        borderBottomWidth: 1,
        borderBottomColor: '#d1fae5'
    },
    listItemImpactoLast: {
        borderBottomWidth: 0
    },
    listLabelImpactoGroup: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 6
    },
    listLabelImpacto: {
        fontSize: 10.5,
        color: '#065f46',
        fontFamily: 'Helvetica-Bold'
    },
    listValueImpacto: {
        fontSize: 13,
        color: '#047857',
        fontFamily: 'Helvetica-Bold'
    },

    /* ================= FOOTER PROLIJO (CON SOPORTE DE IMAGEN) ================= */
    footer: {
        borderTopWidth: 1,
        borderTopColor: '#f0f2f5',
        paddingTop: 10,
        paddingBottom: 15,
        marginHorizontal: 40,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    footerBrandGroup: {
        display: 'flex',
        flexDirection: 'column'
    },
    footerBrand: {
        fontSize: 11,
        fontFamily: 'Helvetica-Bold',
        color: '#00183d',
        letterSpacing: 0.5
    },
    footerSubBrand: {
        fontSize: 8,
        color: '#64748b',
        fontFamily: 'Helvetica',
        marginTop: 1
    },
    footerOfficialGroup: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        height: 20,
        gap: 12
    },
    footerCompanyLogo: {
        height: 20,
        width: 120,
        objectFit: 'contain'
    },
    footerDivider: {
        width: 1,
        height: '100%',
        backgroundColor: '#cbd5e1'
    },
    footerLegal: {
        fontSize: 8,
        color: '#64748b',
        fontFamily: 'Helvetica-Bold',
        textTransform: 'uppercase'
    }
});

const getLogoUrl = (compania) => {
    const cleanName = compania ? compania.toUpperCase().trim() : '';
    
    // Obtenemos dinámicamente el origen del host (ej: http://localhost:3000 o el dominio de producción)
    const origin = typeof window !== 'undefined' ? window.location.origin : '';
    const basePath = `${origin}/logos/`;
    
    if (cleanName.includes('SMG') || cleanName.includes('SWISS') || cleanName.includes('MEDICAL')) {
        return `${basePath}smg.png`;
    }
    if (cleanName.includes('PREVENCION') || cleanName.includes('SANCOR')) {
        return `${basePath}prevencion.png`;
    }
    if (cleanName.includes('GALENO')) {
        return `${basePath}galeno.png`;
    }
    if (cleanName.includes('PROVINCIA')) {
        return `${basePath}provincia.png`;
    }
    if (cleanName.includes('EXPERTA')) {
        return `${basePath}experta.png`;
    }
    if (cleanName.includes('ASOCIART')) {
        return `${basePath}asociart.png`;
    }
    if (cleanName.includes('LA SEGUNDA')) {
        return `${basePath}lasegunda.png`;
    }
    if (cleanName.includes('BERKLEY')) {
        return `${basePath}berkley.png`;
    }
    if (cleanName.includes('OMINT')) {
        return `${basePath}omint.png`;
    }
    if (cleanName.includes('ANDINA')) {
        return `${basePath}andina.png`;
    }
    if (cleanName.includes('FEDERACION')) {
        return `${basePath}federacion.png`;
    }
    if (cleanName.includes('PARANA')) {
        return `${basePath}parana.png`;
    }
    if (cleanName.includes('RECONQUISTA')) {
        return `${basePath}reconquista.png`;
    }
    if (cleanName.includes('IAPSER')) {
        return `${basePath}iapser.png`;
    }
    
    return ''; 
};

// --- ICONOS VECTORIALES COMPATIBLES ---
const IconoEscudoHeader = () => (
    <Svg width="32" height="32" viewBox="0 0 24 24" style={{ marginRight: 6 }}>
        <Path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
        <Path d="M12 8v8M8 12h8" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    </Svg>
);

const IconLineChartDown = () => (
    <Svg width="12" height="12" viewBox="0 0 24 24">
        <Path d="M23 18l-8-8-4 4-9-9" fill="none" stroke="#047857" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
        <Path d="M17 18h6v-6" fill="none" stroke="#047857" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    </Svg>
);

const IconMoney = () => (
    <Svg width="12" height="12" viewBox="0 0 24 24">
        <Rect x="2" y="5" width="20" height="14" rx="2" fill="none" stroke="#047857" strokeWidth="2" />
        <Path d="M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" fill="none" stroke="#047857" strokeWidth="2" />
        <Path d="M6 9h.01M18 15h.01" stroke="#047857" strokeWidth="2.5" strokeLinecap="round" />
    </Svg>
);

const IconGift = () => (
    <Svg width="12" height="12" viewBox="0 0 24 24">
        <Path d="M20 12v10H4V12" fill="none" stroke="#047857" strokeWidth="2" strokeLinejoin="round" />
        <Path d="M2 7h20v5H2z" fill="none" stroke="#047857" strokeWidth="2" strokeLinejoin="round" />
        <Path d="M12 22V7M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z" fill="none" stroke="#047857" strokeWidth="2" strokeLinejoin="round" />
        <Path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z" fill="none" stroke="#047857" strokeWidth="2" strokeLinejoin="round" />
    </Svg>
);

const PlantillaCotizacionArt = ({
    cotizacion,
    oferta,
    stats,
    fetchedClient,
    clientCuit,
    empleados,
    masaSalarial,
    alicuotaActual,
    costoMensualActual,
    costoAnualActual,
    costoPorCapitaActual,
    formatCurrency,
    formatPercent
}) => {
    const fmtCurrency = formatCurrency || ((val) => new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS', minimumFractionDigits: 0 }).format(val || 0));
    const fmtPercent = formatPercent || ((val) => `${Number(val || 0).toFixed(2).replace('.', ',')}%`);

    const nombreAsegurado = useMemo(() => {
        if (!cotizacion) return 'CLIENTE';
        const nom = cotizacion.clienteNombre || cotizacion.entidadNombre || '';
        const ape = cotizacion.clienteApellido || '';
        return `${nom} ${ape}`.trim().toUpperCase() || 'CLIENTE';
    }, [cotizacion]);

    if (!cotizacion || !oferta) return null;

    const cuitFinal = clientCuit || cotizacion.clienteCuit || cotizacion.entidadCuit || '-';
    const capitasFinal = parseInt(empleados || cotizacion.capitas || cotizacion.cantEmpleados || 1, 10);
    const masaSalarialFinal = parseFloat(masaSalarial || cotizacion.masaSalarial || 0);
    const alicuotaActualFinal = parseFloat(alicuotaActual !== undefined ? alicuotaActual : (cotizacion.alicuotaActual || 0));

    const alicuotaPropuesta = parseFloat(oferta.alicuotaCotizada || 0);

    const costoMensualActualFinal = parseFloat(costoMensualActual || (masaSalarialFinal * (alicuotaActualFinal / 100)));
    const costoAnualActualFinal = parseFloat(costoAnualActual || (costoMensualActualFinal * 13));
    const costoPorCapitaActualFinal = parseFloat(costoPorCapitaActual || (capitasFinal > 0 ? (costoMensualActualFinal / capitasFinal) : 0));

    const costoMensualPropuesto = parseFloat(stats?.costoMensual || (masaSalarialFinal * (alicuotaPropuesta / 100)));
    const costoPorCapitaPropuesto = parseFloat(stats?.costoPorCapita || (capitasFinal > 0 ? (costoMensualPropuesto / capitasFinal) : 0));
    const costoAnualPropuesto = parseFloat(stats?.costoAnual || (costoMensualPropuesto * 13));

    const difPercent = stats?.diferenciaPorcentual !== undefined ? stats.diferenciaPorcentual : (alicuotaActualFinal > 0 ? (((alicuotaPropuesta - alicuotaActualFinal) / alicuotaActualFinal) * 100) : 0);
    const difMensual = stats?.diferenciaMensual !== undefined ? stats.diferenciaMensual : (costoMensualPropuesto - costoMensualActualFinal);
    const difAnual = stats?.diferenciaAnual !== undefined ? stats.diferenciaAnual : (difMensual * 13);

    const logoCiaUrl = getLogoUrl(oferta.compania);

    return (
        <Document title={`Propuesta_ART_${nombreAsegurado}`}>
            <Page size="A4" style={styles.page}>
                <View style={styles.cuerpoSuperior}>
                    
                    {/* HEADER */}
                    <View style={styles.header}>
                        <IconoEscudoHeader />
                        <View style={styles.headerTextGroup}>
                            <Text style={styles.titulo}>¡Hola! Te acercamos tu cotización.</Text>
                            <Text style={styles.subtitulo}>Presupuesto de ART</Text>
                        </View>
                    </View>

                    {/* TARJETA DE VIGENCIA */}
                    <View style={[styles.card, { marginTop: -22 }]} wrap={false}>
                        <View style={styles.cardHeaderDouble}>
                            <Text style={styles.cardHeaderDoubleTitulo}>Nº de Cotización</Text>
                            <Text style={styles.cardHeaderDoubleTitulo}>Fecha de Emisión</Text>
                        </View>
                        <View style={styles.cardBodyDouble}>
                            <Text style={styles.cardBodyDatoBlue}>
                                {cotizacion.numeroCotizacion || `COT-${cotizacion.id?.slice(0, 6).toUpperCase()}`}
                            </Text>
                            <Text style={styles.cardBodyDatoMuted}>
                                {cotizacion.fechaCarga 
                                    ? new Date(cotizacion.fechaCarga).toLocaleDateString('es-AR') 
                                    : new Date().toLocaleDateString('es-AR')}
                            </Text>
                        </View>
                    </View>

                    {/* DATOS DE LA EMPRESA */}
                    <View style={styles.card} wrap={false}>
                        <View style={styles.cardHeader}>
                            <Text style={styles.cardHeaderTitulo}>Información de la Cuenta</Text>
                        </View>
                        <View style={styles.cardBodyList}>
                            <View style={styles.listItem}>
                                <Text style={styles.listLabel}>Razón Social</Text>
                                <Text style={styles.listValue}>{nombreAsegurado}</Text>
                            </View>
                            <View style={styles.listItem}>
                                <Text style={styles.listLabel}>CUIT</Text>
                                <Text style={styles.listValue}>{cuitFinal}</Text>
                            </View>
                            <View style={styles.listItem}>
                                <Text style={styles.listLabel}>Cantidad de Empleados</Text>
                                <Text style={styles.listValue}>{capitasFinal + ' cápitas'}</Text>
                            </View>
                            <View style={styles.listItem}>
                                <Text style={styles.listLabel}>Masa Salarial</Text>
                                <Text style={styles.listValue}>{fmtCurrency(masaSalarialFinal)}</Text>
                            </View>
                            <View style={[styles.listItem, styles.listItemLast]}>
                                <Text style={styles.listLabel}>Actividad (CIIU)</Text>
                                <View style={styles.chipCiiu}>
                                    <Text style={styles.chipCiiuText}>{cotizacion.ciiu || 'No esp.'}</Text>
                                </View>
                            </View>
                        </View>
                    </View>

                    {/* TABLA COMPARATIVA */}
                    <View style={styles.tabla} wrap={false}>
                        <View style={[styles.fila, styles.filaHeader]}>
                            <View style={[styles.celda, styles.celdaHeaderLabel]}><Text style={styles.textHeaderLabel}>CONCEPTOS</Text></View>
                            <View style={[styles.celda, styles.celdaHeaderDato]}><Text style={styles.textHeaderDato}>SITUACIÓN ACTUAL</Text></View>
                            <View style={[styles.celda, styles.celdaHeaderDatoLast]}><Text style={styles.textHeaderDato}>NUEVA PROPUESTA</Text></View>
                        </View>

                        <View style={styles.fila}>
                            <View style={[styles.celda, styles.celdaLabel]}><Text style={styles.textCeldaLabel}>Aseguradora (ART)</Text></View>
                            <View style={[styles.celda, styles.celdaDato]}><Text style={styles.textCeldaDato}>{cotizacion.artActual || 'S/D'}</Text></View>
                            <View style={[styles.celda, styles.celdaDatoLast]}><Text style={styles.textCeldaDato}>{oferta.compania}</Text></View>
                        </View>

                        <View style={styles.fila}>
                            <View style={[styles.celda, styles.celdaLabel]}><Text style={styles.textCeldaLabel}>Alícuota Cotizada</Text></View>
                            <View style={[styles.celda, styles.celdaDato]}>
                                <View style={styles.chip}>
                                    <Text style={styles.chipText}>{fmtPercent(alicuotaActualFinal)}</Text>
                                </View>
                            </View>
                            <View style={[styles.celda, styles.celdaDatoLast]}>
                                <View style={styles.chipGreen}>
                                    <Text style={styles.chipGreenText}>{fmtPercent(alicuotaPropuesta)}</Text>
                                </View>
                            </View>
                        </View>

                        <View style={styles.fila}>
                            <View style={[styles.celda, styles.celdaLabel]}><Text style={styles.textCeldaLabel}>Costo promedio por Cápita</Text></View>
                            <View style={[styles.celda, styles.celdaDato]}><Text style={styles.textCeldaDato}>{fmtCurrency(costoPorCapitaActualFinal)}</Text></View>
                            <View style={[styles.celda, styles.celdaDatoLast]}><Text style={[styles.textCeldaDato, { color: '#047857' }]}>{fmtCurrency(costoPorCapitaPropuesto)}</Text></View>
                        </View>

                        <View style={styles.fila}>
                            <View style={[styles.celda, styles.celdaLabel]}><Text style={styles.textCeldaLabel}>Costo Mensual Estimado</Text></View>
                            <View style={[styles.celda, styles.celdaDato]}><Text style={styles.textCeldaDato}>{fmtCurrency(costoMensualActualFinal)}</Text></View>
                            <View style={[styles.celda, styles.celdaDatoLast]}><Text style={[styles.textCeldaDato, { color: '#047857' }]}>{fmtCurrency(costoMensualPropuesto)}</Text></View>
                        </View>

                        <View style={[styles.fila, { borderBottomWidth: 0 }]}>
                            <View style={[styles.celda, styles.celdaTotalLabel]}><Text style={styles.textTotalLabel}>Costo Proyectado Anual</Text></View>
                            <View style={[styles.celda, styles.celdaTotalDato]}>
                                <View style={styles.chip}>
                                    <Text style={styles.chipTextFinal}>{fmtCurrency(costoAnualActualFinal)}</Text>
                                </View>
                            </View>
                            <View style={[styles.celda, styles.celdaTotalDatoLast]}>
                                <View style={styles.chipGreen}>
                                    <Text style={styles.chipGreenTextFinal}>{fmtCurrency(costoAnualPropuesto)}</Text>
                                </View>
                            </View>
                        </View>
                    </View>

                    {/* COMPARATIVO DE AHORROS */}
                    <View style={styles.cardImpacto} wrap={false}>
                        <View style={styles.cardImpactoHeader}>
                            <Text style={styles.cardHeaderImpactoTitulo}>IMPACTO FINANCIERO DE LA PROPUESTA</Text>
                        </View>
                        <View style={styles.cardBodyList}>
                            <View style={styles.listItemImpacto}>
                                <View style={styles.listLabelImpactoGroup}>
                                    <IconLineChartDown />
                                    <Text style={styles.listLabelImpacto}>Reducción de Alícuota (OFF)</Text>
                                </View>
                                <Text style={styles.listValueImpacto}>
                                    {fmtPercent(Math.abs(difPercent))}
                                </Text>
                            </View>
                            <View style={styles.listItemImpacto}>
                                <View style={styles.listLabelImpactoGroup}>
                                    <IconMoney />
                                    <Text style={styles.listLabelImpacto}>Ahorro Mensual Inmediato</Text>
                                </View>
                                <Text style={styles.listValueImpacto}>
                                    {fmtCurrency(Math.abs(difMensual))}
                                </Text>
                            </View>
                            <View style={[styles.listItemImpacto, styles.listItemImpactoLast]}>
                                <View style={styles.listLabelImpactoGroup}>
                                    <IconGift />
                                    <Text style={styles.listLabelImpacto}>Proyección de Ahorro Anual (SAC inc.)</Text>
                                </View>
                                <Text style={styles.listValueImpacto}>
                                    {fmtCurrency(Math.abs(difAnual))}
                                </Text>
                            </View>
                        </View>
                    </View>
                </View>

                {/* FOOTER */}
                <View style={styles.footer} wrap={false}>
                    <View style={styles.footerBrandGroup}>
                        <Text style={styles.footerBrand}>IB BROKERS INSURANCE</Text>
                        <Text style={styles.footerSubBrand}>Asesoría Integral de Seguros y ART</Text>
                    </View>
                    <View style={styles.footerOfficialGroup}>
                        {logoCiaUrl ? (
                            <Image src={logoCiaUrl} style={styles.footerCompanyLogo} />
                        ) : null}
                        <View style={styles.footerDivider} />
                        <Text style={styles.footerLegal}>PRESUPUESTO OFICIAL</Text>
                    </View>
                </View>
            </Page>
        </Document>
    );
};

export default PlantillaCotizacionArt;